import React from 'react'
import { StyledLineDivisorContainer } from './styles';



interface LineDivisorProps {
    onlyMobile: boolean;
}
const LineDivisor: React.FC<LineDivisorProps> = (props) => {
    const {onlyMobile} = props;
  return (
    <StyledLineDivisorContainer className={`line-divisor ${onlyMobile ? "mobile-view" : "all-views"}`}/>
  )
}

export default LineDivisor